import React from "react";
import Todo from "../todo/Todo";
import styled from "styled-components";
import { useSelector } from "react-redux";

function List() {
     const Todos = useSelector((state) => state.Todos); // 등록한 데이터를 가져옴(store 조회)
     const workingList = Todos.filter((item) => item.isDone === false);
     // 등록한 데이터들의 각 요소의 isDone이 false인 요소들 걸러냄
     const doneList = Todos.filter((item) => item.isDone === true);
     return (
          <ListContainer>
               <h2 className="list-title">Working..✍🏻</h2>
               <StyleList>
                    {workingList.map((doList) => (
                         <Todo
                              doList={doList} //props
                              key={doList.id} // todo 의 리스트를 변경해주기 위해
                         />
                    ))}
               </StyleList>
               <h2 className="list-title">Done..!</h2>
               <StyleList>
                    {doneList.map((doList) => (
                         // 위에서 필터된 doneList에 있는 요소를 하나씩 전달받아 Todo 컴포넌트로 된 배열을 만듬
                         <Todo doList={doList} key={doList.id} />
                    ))}
               </StyleList>
          </ListContainer>
     );
}

export default List;

const ListContainer = styled.div`
     max-width: 1200px;
     min-width: 800px;
     height: auto;
     display: flex;
     flex-direction: column;
     h2 {
          padding: 10px 20px;
          font-size: 35px;
          margin-top: 15px;
     }
`;
const StyleList = styled.div`
     width: 100%;
     height: 360px;
     display: flex;
     flex-wrap: nowrap;
     align-items: center;
     padding: 5px 20px;
     gap: 20px;
     object-fit: auto;
     overflow-x: scroll;
     ::-webkit-scrollbar {
          width: 5px;
          height: 10px;
          border-radius: 10px;
     }
     ::-webkit-scrollbar-thumb {
          height: 10%;
          background-color: rgb(80, 80, 80);

          border-radius: 10px;
     }
     ::-webkit-scrollbar-track {
          background: transparent;
     }
`;
